export const scrollToElementWithOffset = (
  element: Element | HTMLElement,
  offset: number
) => {
  if (!element) {
    console.error('Element not found');
    return;
  }

  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;

  window.scrollTo({
    // top: middle - offset,
    top: absoluteElementTop - offset,
    behavior: 'smooth',
  });
};

export const scrollToElementWithOffsetNew = (
  element: HTMLElement,
  offset: number
) => {
  if (!element) {
    console.error('Element not found');
    return;
  }

  const elementRect = element.getBoundingClientRect();
  const targetY = elementRect.top + window.pageYOffset - offset;

  const startY = window.pageYOffset;
  const distance = targetY - startY;
  const duration = 800;
  const startTime = performance.now();

  const easeInOut = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

  const animateScroll = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOut(progress);

    window.scrollTo(0, startY + distance * easedProgress);

    if (elapsed < duration) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
};
